<style scoped lang="scss"></style>

<template>
  <v-table
    class="affiliate-table"
    url="/api/v1/affiliate"
    :appends="['soi_and_doi_today', 'soi_and_doi_total']"
    :attributes="[
      {
        attribute: 'id',
        name: 'ID'
      },
      {
        attribute: 'created_at',
        name: 'Erstellt am',
        type: 'DateCell'
      },
      {
        attribute: 'description',
        name: 'Beschreibung',
        customStyle: 'max-width: 300px;'
      },
      {
        attribute: 'partner',
        name: 'Werbepartner'
      },
      {
        attribute: 'quota',
        name: 'Kontingent'
      },
      {
        attribute: 'one_click_passing',
        name: '1CP',
        type: 'CheckMarkerCell'
      },
      {
        attribute: 'cpm',
        name: 'TKP',
        type: 'CurrencyCell'
      },
      {
        attribute: 'cpl',
        name: 'CPL',
        type: 'CurrencyCell',
        sortable: false
      },
      {
        attribute: 'soi_and_doi_today',
        name: iconNewVerifiedCustomersToday,
        html: true,
        tooltip: 'Mitglieder Heute / SOI und DOI',
        sortable: false
      },
      {
        attribute: 'soi_and_doi_total',
        name: iconNewVerifiedCustomersTotal,
        html: true,
        tooltip: 'Mitglieder Gesamt / SOI und DOI',
        sortable: false
      },
      {
        attribute: 'page_visits',
        name: iconPageVisits,
        html: true,
        tooltip: 'Seitenaufrufe Heute / Gesamt',
        sortable: false
      },
      {
        attribute: 'today_revenue',
        name: iconIncomeToday,
        html: true,
        type: 'CurrencyCell',
        tooltip: 'Einnahmen Heute',
        sortable: false
      },
      {
        attribute: 'total_revenue',
        name: iconIncomeTotal,
        html: true,
        type: 'ModalCell',
        modal: 'AffiliateUserRevenueModal',
        mode: 'userCurrency',
        tooltip: 'Einnahmen Total',
        sortable: false
      },
      {
        name: 'Aktionen',
        type: 'AffiliateActionCell'
      }
    ]"
  ></v-table>
</template>

<script lang="babel">
export default {
   data() {
    return {
      iconNewVerifiedCustomersToday: '<i class="fas fa-users"></i><i class="far fa-clock"></i>',
      iconNewVerifiedCustomersTotal: '<i class="fas fa-users"></i><i class="fas fa-globe-europe"></i>',
      iconPageVisits: 'P.I. <i class="far fa-clock"></i><i class="fas fa-globe-europe"></i>',
      iconIncomeToday: '<i class="fas fa-wallet"></i> / <i class="far fa-clock"></i>',
      iconIncomeTotal: '<i class="fas fa-wallet"></i> / <i class="fas fa-globe-europe"></i>',
    };
  },
}
</script>
